import store from "../store";
import platformBillingLock from "./platformBillingLock";

export default async function auth({ next, to, from, router }) {

  if (!store.getters["auth/isAuthenticated"]) {
    return next({ name: "Login" });
  }

  try {
    await store.dispatch("profile/me");
    return platformBillingLock({ next, to, from, router });
  } catch (error) {
    try {
      await store.dispatch("auth/logout");
    } finally {
      // eslint-disable-next-line no-unsafe-finally
      return next({ name: "Login" });
    }
  }
}
